import axios from "axios";
import update from "lodash/fp/update";
import map from "lodash/fp/map";
import find from "lodash/fp/find";

const buildProduct = (products) => (product) => {
  if (!product?.parentId) {
    return product;
  }

  const baseProduct = find({ id: product.parentId })(products);

  return {
    ...baseProduct,
    ...product,
  };
};

export default function fetchProductFormData({ signal }) {
  const source = axios.CancelToken.source();

  if (signal) {
    signal.addEventListener("abort", () => {
      source.cancel();
    });
  }

  return ({ productFormDataUrl }) =>
    axios
      .get(productFormDataUrl, {
        cancelToken: source.token,
      })
      .then((response) => {
        return response.data;
      })
      .then((initialFormData) => {
        return update(
          "products",
          map(buildProduct(initialFormData.products))
        )(initialFormData);
      });
}
